import Home, * as home from 'pages/Home';
import ProductManagement, * as productManagement from 'pages/ProductManagement';
import ProductsUpload from 'pages/ProductManagement/subPages/ProductsUpload';
import AliasesUpload from 'pages/ProductTitles/subPages/AliasesUpload';
import TitleSplitUpload from 'pages/ProductTitles/subPages/TitleSplitUpload';
import ProductTitlesManagement, * as productTitlesManagement from 'pages/ProductTitles';
import KeywordsManagement, * as keywordsManagement from 'pages/Keywords';
import UserManagement, * as userManagement from 'pages/UserManagement';
import UserEdit from 'pages/UserManagement/components/Molecules/MUserEdit/UserEdit';
import UsersUpload from 'pages/UserManagement/components/SubPages/UserUpload';
import ImageManagment, * as imageManagement from 'pages/ImageManagement';
import ImageUpload from 'pages/ImageManagement/components/organisms/ImagesUpload/ImagesUpload';
import History, * as history from 'pages/History';
import Preferences, * as preferences from 'pages/Preferences';
import ListManagement, * as listManagement from 'pages/ListManagement';
import Sectorisation, * as sectorisation from 'pages/Sectorisation';
import SalesData, * as salesData from 'pages/SalesData';
import MListDataViewer from 'pages/ListManagement/components/Molecules/MListDataViewer';
import UploadRouter from 'router/UploadRouter';
import ImageDetail from 'pages/ImageManagement/components/organisms/DetailViewer/ImageDetail';
import SectoUpload from 'pages/Sectorisation/SectoUpload';

import icons from 'shared/icons';
import { RouteDec } from 'types';
import { subRoutes, TSubRoute } from './tabsMapper';

import App from '../App';
import SalesDataUpload from 'pages/SalesData/subPages/SalesDataUpload';

const ProductsIcon = icons.productBis;
const KeywordsIcon = icons.keywords;
const UsersIcon = icons.user;
const HomeIcon = icons.home;
const ImagesIcon = icons.image;
const HistoryIcon = icons.history;
const ListManagmentIcon = icons.listManagment;
const SectorisationIcon = icons.sectorisation;
const PreferencesIcon = icons.preferences;

const routes: RouteDec = {
    root: {
        element: App,
        path: '/',
        children: [
            {
                [home.ID]: {
                    element: Home,
                    path: home.PATH,
                    name: home.NAME,
                    icon: (props) => <HomeIcon {...props} />,
                },
                [imageManagement.ID]: {
                    element: ImageManagment,
                    path: imageManagement.PATH,
                    name: imageManagement.NAME,
                    icon: (props) => <ImagesIcon {...props} />,
                    children: [
                        {
                            cdm_image_upload: {
                                element: ImageUpload,
                                path: 'upload',
                            },
                        },
                        {
                            cdm_image_detail: {
                                element: ImageDetail,
                                path: 'detail',
                            },
                        },
                    ],
                },
                [productManagement.ID]: {
                    element: ProductManagement,
                    path: productManagement.PATH,
                    name: productManagement.NAME,
                    icon: (props) => <ProductsIcon {...props} />,
                    children: [
                        {
                            cdm_clientsproduct_upload: {
                                element: ProductsUpload,
                                path: 'upload',
                            },
                            cdm_producttitlesplit_tab: {
                                element: ProductTitlesManagement,
                                path: ':page',
                            },
                            cdm_producttitlesplit_upload: {
                                element: UploadRouter,
                                path: ':page/upload',
                            },
                        },
                    ],
                },
                [keywordsManagement.ID]: {
                    element: KeywordsManagement,
                    path: keywordsManagement.PATH,
                    name: keywordsManagement.NAME,
                    icon: (props) => <KeywordsIcon {...props} />,
                    children: [
                        {
                            cdm_keywords_upload: {
                                element: UploadRouter,
                                path: ':page/upload/',
                            },
                        },
                        {
                            cdm_keywords_tab: {
                                element: KeywordsManagement,
                                path: ':page',
                            },
                        },
                    ],
                },
                [userManagement.ID]: {
                    element: UserManagement,
                    path: userManagement.PATH,
                    name: userManagement.NAME,
                    icon: (props) => <UsersIcon {...props} />,
                    children: [
                        {
                            cdm_usermanager_add: {
                                element: UserEdit,
                                path: ':page/add',
                            },
                            cdm_usermanager_edit: {
                                element: UserEdit,
                                path: ':page/edit',
                            },
                            cdm_usermanager_upload: {
                                element: UsersUpload,
                                path: ':page/upload',
                            },
                            cdm_usermanager_tab: {
                                element: UserManagement,
                                path: ':page',
                            },
                        },
                    ],
                },
                [listManagement.ID]: {
                    element: ListManagement,
                    path: listManagement.PATH,
                    name: listManagement.NAME,
                    icon: (props) => <ListManagmentIcon {...props} />,
                    children: [
                        {
                            cdm_listmanager_list: {
                                element: MListDataViewer,
                                path: ':page/list',
                            },
                            cdm_listmanager_tab: {
                                element: ListManagement,
                                path: ':page',
                            },
                        },
                    ],
                },
                [sectorisation.ID]: {
                    element: Sectorisation,
                    path: sectorisation.PATH,
                    name: sectorisation.NAME,
                    icon: (props) => <SectorisationIcon {...props} />,
                    children: [
                        {
                            cdm_sectomanager_upload: {
                                element: SectoUpload,
                                path: ':page/upload',
                            },
                            cdm_sectomanager_tab: {
                                element: Sectorisation,
                                path: ':page',
                            },
                        },
                    ],
                },

                [salesData.ID]: {
                    element: SalesData,
                    path: salesData.PATH,
                    name: salesData.NAME,

                    icon: (props) => <SectorisationIcon {...props} />,
                    children: [
                        {
                            cdm_sales_data_upload: {
                                element: SalesDataUpload,
                                path: 'upload',
                            },
                            cdm_sales_data_tab: {
                                element: SalesData,
                                path: ':page',
                            },
                        },

                    ],
                },
                [history.ID]: {
                    element: History,
                    path: history.PATH,
                    name: history.NAME,
                    icon: (props) => <HistoryIcon {...props} />,
                },
                [preferences.ID]: {
                    element: Preferences,
                    path: preferences.PATH,
                    name: preferences.NAME,
                    children: [
                        {
                            cdm_colors: {
                                element: Preferences,
                                path: 'colors',
                            },
                        },
                    ],
                    icon: (props) => <PreferencesIcon {...props} />,
                },
            },
        ],
    },
};

export const sideBarRoutes: {
    id: string;
    path: string;
    order: number;
    name: string;
    childs?: TSubRoute[];
}[] = [
    { id: home.ID, path: home.PATH, name: home.NAME, order: 1 },
    { id: imageManagement.ID, path: imageManagement.PATH, name: imageManagement.NAME, order: 2 },
    { id: keywordsManagement.ID, path: keywordsManagement.PATH, name: keywordsManagement.NAME, order: 3 },
    { id: productManagement.ID, path: productManagement.PATH, name: productManagement.NAME, order: 4 },
    { id: userManagement.ID, path: userManagement.PATH, name: userManagement.NAME, order: 5 },
    { id: listManagement.ID, path: listManagement.PATH, name: listManagement.NAME, order: 6 },
    { id: sectorisation.ID, path: sectorisation.PATH, name: sectorisation.NAME, order: 7 },
    { id: history.ID, path: history.PATH, name: history.NAME, order: 8 },
    { id: preferences.ID, path: preferences.PATH, name: preferences.NAME, order: 9 },
].map((route) => ({ ...route, childs: subRoutes[route.path] }));

export default routes;
